import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThumbsUpFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 22 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M20.94 7.7C20.56 7.26 20.01 7.01 19.43 7.01H15.22V3.66C15.22 1.88 14.16 0 12.2 0C11.29 0 10.54 0.74 10.54 1.66V4.74C10.54 7.32 8.44 9.42 5.86 9.42H5.4V8.61C5.4 8.28 5.13 8.01 4.8 8.01H0.6C0.27 8.01 0 8.28 0 8.61V19.05C0 19.38 0.27 19.65 0.6 19.65H4.8C5.13 19.65 5.4 19.38 5.4 19.05V18.63H5.93C6.12 18.63 6.3 18.68 6.46 18.77L7.92 19.68C8.24 19.88 8.6 19.98 8.98 19.98H18.09C19.13 19.98 19.98 19.2 20.08 18.19L21.41 9.31C21.5 8.73 21.33 8.15 20.95 7.71L20.94 7.7ZM4.2 18.43H1.2V9.19H4.2V18.43Z"
	})
});
export { SvgThumbsUpFilled as ReactComponent };
